import React from 'react';
import buildRoute from 'components/buildRoute';

export const CrosstabsStep6 = () => {
    return <div>Step6: Crosstab</div>;
}

const routeArgs = {
  element: <CrosstabsStep6 />,
  loader: async () => {
    return null;
  },
};

export default buildRoute(routeArgs);